import { useTaskTrackerBoardFilterStickers } from './useTaskTrackerBoardFilterStickers'
import { selectTaskTrackerBoardAccessibleStickerRows } from '../../store/taskTracker.selectors'
import { useTaskTrackerSelector } from '../../store/taskTracker.hooks'

export const useTaskTrackerBoardAccessibleStickers = (
  boardId: number | null,
  enabled = true,
) => {
  const effectiveBoardId = enabled ? boardId : null
  const { loading, error } = useTaskTrackerBoardFilterStickers(effectiveBoardId)
  const rows = useTaskTrackerSelector((state) =>
    selectTaskTrackerBoardAccessibleStickerRows(state, effectiveBoardId),
  )

  return {
    rows,
    loading,
    error,
  }
}
